/** @format */
// 产权车 01:正常 02:已过期
export enum propertyCarStatus {
  Wait = '01',
  Effects = '02',
  Expired = '03'
}

export const propertyCarStatusMap: {
  [key: string]: string;
} = {
  [propertyCarStatus.Wait]: '待生效',
  [propertyCarStatus.Effects]: '正常',
  [propertyCarStatus.Expired]: '已过期'
};

// 长租车授权状态  长租车 01:待生效 02:正常 03:已过期 04:冻结 05:已注销（已停租）
export enum longRentalStatus {
  Wait = '01',
  Normal = '02',
  Expired = '03',
  freeze = '04',
  Finish = '05'
}

export const longRentalStatusMap: {
  [key: string]: string;
} = {
  [longRentalStatus.Wait]: '待生效',
  [longRentalStatus.Normal]: '正常',
  [longRentalStatus.Expired]: '已过期',
  [longRentalStatus.freeze]: '冻结',
  [longRentalStatus.Finish]: '已停租'
};

// 长租车车位类型  0: '产权车位',1: '人防车位',2: '自划车位',3: '非固定车位'
export enum longRentalCarType {
  Auth = '0',
  Civil = '1',
  Self = '2',
  NoFixed = '3'
}

export const longRentalCarTypeMap: {
  [key: string]: string;
} = {
  [longRentalCarType.Auth]: '产权车位',
  [longRentalCarType.Civil]: '人防车位',
  [longRentalCarType.Self]: '自划车位',
  [longRentalCarType.NoFixed]: '非固定车位'
};

// 长租车签约申请状态  0: '待审核',1: '审核不通过',2: '审核通过'
export enum longRentalApplyStatus {
  Wait = '01',
  NoPass = '02',
  Pass = '03',
  Failure = '04',
  NoRenview = '05'
}

export const longRentalApplyStatusMap: {
  [key: string]: string;
} = {
  [longRentalApplyStatus.Wait]: '待审核',
  [longRentalApplyStatus.Pass]: '已通过',
  [longRentalApplyStatus.NoPass]: '未通过',
  [longRentalApplyStatus.NoRenview]: '无需审核',
  [longRentalApplyStatus.Failure]: '已取消'
};

// 长租车签约支付状态  01: '支付成功',02: '支付失败',03: '待支付' 04：'无'
export enum longRentalPayStatus {
  Payed = '01',
  Failure = '02',
  Wait = '03',
  None = '04'
}

export const longRentalPayStatusMap: {
  [key: string]: string;
} = {
  [longRentalPayStatus.None]: '无',
  [longRentalPayStatus.Wait]: '待支付',
  [longRentalPayStatus.Payed]: '支付成功',
  [longRentalPayStatus.Failure]: '支付失败'
};

// 长租车签约业务类型  0: '开卡',1: '续费'
export enum longRentalBussinessType {
  Open = '0',
  Renew = '1'
}

export const longRentalBussinessTypeMap: {
  [key: string]: string;
} = {
  [longRentalBussinessType.Open]: '开卡',
  [longRentalBussinessType.Renew]: '续费'
};

// 固定车辆交易记录  0: '平台',1: '第三方',2: 'C端微站点'
export enum TraderecordChannel {
  Platform = '01',
  ThirdParty = '02',
  CSide = '03'
}

export const TraderecordChannelMap: {
  [key: string]: string;
} = {
  [TraderecordChannel.Platform]: '平台',
  [TraderecordChannel.ThirdParty]: '第三方',
  [TraderecordChannel.CSide]: 'C端微站点'
};

// 固定车辆业务类型  0: '产权',1: '长租'
export enum TraderecordBussinessType {
  PropertyCar = '01',
  LongRental = '02'
}

export const TraderecordBussinessTypeMap: {
  [key: string]: string;
} = {
  [TraderecordBussinessType.PropertyCar]: '产权车',
  [TraderecordBussinessType.LongRental]: '长租车'
};

// 固定车辆交易类型  0: '新办',1: '续费',2: '退费'
export enum TraderecordPayType {
  New = '01',
  Renew = '02',
  Refund = '03'
}

export const TraderecordPayTypeMap: {
  [key: string]: string;
} = {
  [TraderecordPayType.New]: '新办',
  [TraderecordPayType.Renew]: '续费',
  [TraderecordPayType.Refund]: '退费'
};

// 固定车辆缴费方式，多个逗号拼接。01:现金 02:微信 03:支付宝 04:银行转账
export enum TraderecordPayMethods {
  New = '01',
  WeiXin = '02',
  Alipay = '03',
  Other = '04'
}

export const TraderecordPayMethodsMap: {
  [key: string]: string;
} = {
  [TraderecordPayMethods.New]: '现金',
  [TraderecordPayMethods.WeiXin]: '微信',
  [TraderecordPayMethods.Alipay]: '支付宝',
  [TraderecordPayMethods.Other]: '其他'
};

// 固定车辆缴费方式，多个逗号拼接。01:现金 02:微信 03:支付宝 04:银行转账 05 银行转账
export enum gudMethods {
  New = '01',
  WeiXin = '02',
  Alipay = '03',
  Other = '04',
  bank = '05'
}

export const gudMethodsMap: {
  [key: string]: string;
} = {
  [gudMethods.New]: '现金',
  [gudMethods.WeiXin]: '微信',
  [gudMethods.Alipay]: '支付宝',
  [gudMethods.Other]: '其他',
  [gudMethods.bank]: '银行转账'
};
// 收费月度分摊表 业务类型
export enum TBsinessType {
  Management = '01',
  Rent = '02'
}
export const TBsinessTypeMap: {
  [key: string]: string;
} = {
  [TBsinessType.Management]: '车位管理费',
  [TBsinessType.Rent]: '车位租赁费'
};

// 长城 新加 记录类型：00 挂起 01正常 02已删除 多个逗号分隔
export enum recordchchType {
  Managements = '00',
  Management = '01',
  Rent = '02'
}
export const recordchchTypeMap: {
  [key: string]: string;
} = {
  [recordchchType.Managements]: '挂起',
  [recordchchType.Management]: '正常',
  [recordchchType.Rent]: '已删除'
};

//发送状态  发送中（等待回执）、发送成功、发送失败
export enum sendStatus {
  Fail = '00', //失败
  Success = '01', //成功
  Sending = '02' //中
}
export const sendStatusMap: {
  [key: string]: string;
} = {
  [sendStatus.Fail]: '发送失败',
  [sendStatus.Success]: '发送成功',
  [sendStatus.Sending]: '发送中（等待回执）'
};

// 授权状态   01:待生效 02:正常 03:已过期 04:冻结 05:已注销（已停租）
export enum authStatus {
  Wait = '01',
  Normal = '02',
  Expired = '03'
  // freeze = '04',
  // Finish = '05',
}

export const authStatusMap: {
  [key: string]: string;
} = {
  [authStatus.Wait]: '待生效',
  [authStatus.Normal]: '正常',
  [authStatus.Expired]: '已过期'
  // [authStatus.freeze]: '冻结',
  // [authStatus.Finish]: '已停租',
};
